import React, { useState } from "react";
import { Plus, FileText, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { TemplatesGallery } from "./TemplatesGallery";

interface EmptyStateWithTemplatesProps {
  onCreateBlank: () => void;
  onSelectTemplate: (template: any) => void;
}

function EmptyStateWithTemplates({ 
  onCreateBlank, 
  onSelectTemplate 
}: EmptyStateWithTemplatesProps) {
  const [showTemplates, setShowTemplates] = useState(false);

  if (showTemplates) {
    return (
      <div className="h-full">
        <div className="mb-4 p-4 border-b">
          <Button 
            variant="ghost" 
            onClick={() => setShowTemplates(false)}
            className="mb-2"
          >
            ← Back to start
          </Button>
        </div>
        <TemplatesGallery onSelectTemplate={onSelectTemplate} />
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-center">
      <Card className="w-full max-w-md mx-auto">
        <CardContent className="p-8 text-center space-y-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
            <Sparkles className="w-8 h-8 text-primary" />
          </div>
          
          <div>
            <h2 className="text-2xl font-bold mb-2">Create Your First Whiteboard</h2>
            <p className="text-muted-foreground">
              Start with a blank canvas or choose from our professional templates
            </p>
          </div>
          
          <div className="space-y-3">
            <Button onClick={onCreateBlank} className="w-full gap-2">
              <Plus className="w-4 h-4" />
              Start with Blank Canvas
            </Button>
            
            <Button 
              variant="outline" 
              onClick={() => setShowTemplates(true)}
              className="w-full gap-2"
            >
              <FileText className="w-4 h-4" />
              Browse Templates
            </Button>
          </div>
          
          <div className="text-xs text-muted-foreground">
            Tip: Press <kbd className="px-1 py-0.5 bg-muted rounded">⌘N</kbd> to create a new whiteboard anytime
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export { EmptyStateWithTemplates };